<template>
    <v-menu
        v-model="menuOpen"
        offset-y
        :close-on-content-click="false"
    >
        <template v-slot:activator="{ on }">
            <v-combobox
                v-model="model"
                v-bind="$attrs"
                :items="[]"
                v-on="{...$listeners, ...on, click: () => {menuOpen = true} }"
                :filter="filter"
                :hide-no-data="isHideNoData"
                :search-input.sync="search"
                :disabled="disabled"
            >
                <!--
                Как можно увидеть вот этот слот? - вводить цвет с клавиатуры, при закрытом пикере
                -->
                <template v-slot:no-data>
                    <v-list-item class="add-new-value" @click="addNewValue">
                        <span class="subheading" v-if="isValidColor(search)">Добавить</span>
                        <v-chip v-if="isValidColor(search)" :color="cssColorToHex(search)" :dark="isDark(search)" label
                                small>{{ search }}{{ postfix }}
                        </v-chip>
                        <v-chip v-else color="red lighten-3" label small>Недопустимое значение {{ search }}</v-chip>
                    </v-list-item>
                </template>
                <template v-slot:selection="{ attrs, item, parent, selected }">
                    <v-chip
                        v-if="isValidColor(item)"
                        v-bind="attrs"
                        :color="cssColorToHex(item)"
                        :dark="isDark(item)"
                        :input-value="selected"
                        label
                        small
                        :disabled="disabled"
                    >
                        <span class="pr-2">{{ item }}{{ postfix }}</span>
                        <v-icon small @click="parent.selectItem(item)">$delete</v-icon>
                    </v-chip>
                    <span v-else class="error-chip">{{ item }} <v-icon small
                                                                       @click="parent.selectItem(item)">$delete</v-icon></span>
                </template>
            </v-combobox>
        </template>
        <!--
        @TODO На потом! Иногда оно открывает его на click/focus, а иногда на dblclick...
        -->
        <!-- Контент меню: показываем color-picker -->
        <v-card class="mx-auto" max-width="300">
            <v-color-picker
                v-model="color"
                show-canvas
                hide-inputs
                show-swatches
                flat
            ></v-color-picker>
            <v-card-actions class="pa-8 py-5">
                <v-row
                    align="center"
                    justify="end"
                >
                    <v-btn
                        @click="menuOpen = false;"
                        small
                    >
                        Отмена
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="handleColorInput(color);"
                        small
                        class="ml-2"
                    >
                        Ok
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-menu>
</template>
<script>

export default {
    name: 'ColorCombobox',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        postfix: String,
        disabled: Boolean,
    },
    data: () => ({
        menuOpen: false,
        search: null,
        color: 'white', // выбранный цвет из color-picker
        canvas: null,
    }),
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            }
        },
        isHideNoData() {
            return !this.search || this.menuOpen;
        },
    },
    watch: {
        model: {
            handler(colors) {
                if (!colors?.length) {
                    return;
                }
                const validColors = this._(colors).filter(v => this.isValidColor(v)).map(v => {
                    if (v.startsWith('#')) {
                        if (v.length === 9 && v.substr(-2).toLowerCase() === 'ff') {
                            return v.substr(0, 7).toUpperCase();
                        }
                        return v.toUpperCase();
                    }
                    return v.toLowerCase();
                }).value();
                if (this._(validColors).xorWith(colors, this._.isEqual).isEmpty()) {
                    return;
                }
                this.$emit('input', validColors);
            },
            deep: true,
        },
    },
    created() {
        this.canvas = document.createElement('canvas').getContext('2d');
    },
    beforeDestroy() {
        this.canvas = null;
    },
    methods: {
        rgbToHex(color) {
            if (!color) {
                return '#00000000';
            }
            const regex = /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})(?:\s*,\s*([0-9.]+))?\s*\)$/;
            const result = regex.exec(color);
            if (!result) {
                throw new Error("Неверный формат цвета");
            }
            const r = parseInt(result[1], 10);
            const g = parseInt(result[2], 10);
            const b = parseInt(result[3], 10);
            const a = result[4] !== undefined ? parseFloat(result[4]) : 1;
            const toHex = (num) => {
                const hex = num.toString(16);
                return hex.length === 1 ? '0' + hex : hex;
            };
            const hexR = toHex(r);
            const hexG = toHex(g);
            const hexB = toHex(b);
            if (a < 1) {
                const alphaHex = toHex(Math.round(a * 255));
                return `#${hexR}${hexG}${hexB}${alphaHex}`;
            } else {
                return `#${hexR}${hexG}${hexB}`;
            }
        },
        cssColorToHex(cssColor) {
            this.canvas.fillStyle = cssColor;
            cssColor = this.canvas.fillStyle.startsWith('rgb') ? this.rgbToHex(this.canvas.fillStyle) : this.canvas.fillStyle;
            return cssColor;
        },
        addNewValue() {
            if (this.isValidColor(this.search)) {
                if (!this.model.includes(this.search)) {
                    let res = this.search;
                    this.model.push(res);
                }
                this.search = '';
            } else {
                console.warn('Недопустимое значение:', this.search);
            }
        },
        filter(item, queryText, itemText) {
            if (item.header) {
                return false;
            }
            const hasValue = val => val != null ? val : '';
            const text = hasValue(itemText);
            const query = hasValue(queryText);
            return text.toString()
                .toLowerCase()
                .indexOf(query.toString().toLowerCase()) > -1;
        },
        handleColorInput(color) {
            if (!this.model.includes(color)) {
                this.model.push(color);
            }
            this.menuOpen = false;
        },
        isValidCssColor(color) {
            const s = new Option().style;
            s.color = color;
            return s.color !== '';
        },
        isValidColor(color) {
            if (!color) {
                return false;
            }
            const hexColor = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i;
            const rgbColor = /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/;
            const rgbaColor = /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*([\d.]+?)\)$/;
            return hexColor.test(color) || rgbColor.test(color) || rgbaColor.test(color) || this.isValidCssColor(color.toLowerCase());
        },
        isDark(color) {
            let r, g, b, a = 1;
            // hex-формат
            if (!this.isValidCssColor(color)) {
                return true;
            }
            color = this.cssColorToHex(color);
            if (color.length === 4) {
                r = parseInt(color[1] + color[1], 16);
                g = parseInt(color[2] + color[2], 16);
                b = parseInt(color[3] + color[3], 16);
            } else if (color.length === 7) {
                r = parseInt(color.slice(1, 3), 16);
                g = parseInt(color.slice(3, 5), 16);
                b = parseInt(color.slice(5, 7), 16);
            } else if (color.length === 9) {
                r = parseInt(color.slice(1, 3), 16);
                g = parseInt(color.slice(3, 5), 16);
                b = parseInt(color.slice(5, 7), 16);
                // Приводим альфа-канал к 0..1
                a = parseInt(color.slice(7, 9), 16) / 255;
            }
            // Предполагаем, что фон — белый (255,255,255)
            const background = 255;
            // компоненты цвета с учетом альфа-канала
            const effectiveR = r * a + background * (1 - a);
            const effectiveG = g * a + background * (1 - a);
            const effectiveB = b * a + background * (1 - a);
            // яркость по стандартной формуле
            const brightness = (effectiveR * 299 + effectiveG * 587 + effectiveB * 114) / 1000;
            return brightness < 128;
        },
    }
};
</script>
<style scoped lang="scss">
.error-chip {
    background: #fff;
    border: 1px dashed red;
    color: red;
    padding: 2px 6px;
    border-radius: 3px;
    margin: 4px 4px 4px 0;
    opacity: 0.6;
}

::v-deep .add-new-value {
    display: flex;
    gap: 7px;
}

::v-deep .v-list-item {
    min-height: 32px;

    .v-chip {
        min-width: 38px;
        display: inline-block;
        text-align: right;
    }
}

.v-select.v-select--chips.v-select--chips--small ::v-deep .v-select__selections {
    min-height: 32px;
}

.v-select ::v-deep .v-chip {
    padding: 0 6px;
    margin: 4px 4px 4px 0;
}

.v-menu__content {
    //box-shadow: none!important;
    margin: 0;
    padding: 0;

    &.menuable__content__active {
        min-width: 300px !important;
    }
}
</style>
